module.exports = __webpack_public_path__ + "static/media/homevideo_mobile.84508796.svg";